import React, { useState } from "react";
import "./style.css";
import profileImage from "../Images/01.jpg";
import { SiPicartodottv } from "react-icons/si";
import { FaHome, FaRegBell, FaSearch } from "react-icons/fa";
import { HiOutlineViewGrid } from "react-icons/hi";
import { Form } from "react-bootstrap";
import { HiMiniChevronDown, HiMiniChevronUp } from "react-icons/hi2";
import { FiPlus, FiCheck } from "react-icons/fi";
import { LuSlidersHorizontal } from "react-icons/lu";
import { Collapse } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const MainHeader = () => {
  const genres = [
    "Action",
    "Comedy",
    "Drama",
    "Thriller",
    "Adventure",
    "Crime",
    "Family",
    "Fantasy",
    "Historical",
    "Horror",
    "Mystery",
    "Romance",
    "Science Fiction",
    "TV Movie",
    "War",
    "Western",
    "Sci-fiction",
  ];
  const [open, setOpen] = useState(false);
  const [selectedGenres, setSelectedGenres] = useState([]);

  const handleGenreClick = (genre) => {
    if (selectedGenres.includes(genre)) {
      setSelectedGenres(selectedGenres.filter((g) => g !== genre));
    } else {
      setSelectedGenres([...selectedGenres, genre]);
    }
  };

  const toggleDropdown = () => setOpen(!open);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-2 px-4">
        <div className="hstack gap-5">
          <NavLink to={"/home"}>
            <div className="text-white fs-22 fw-bold">
              Galax <SiPicartodottv className="me-1" />
            </div>
          </NavLink>
          <div className="d-flex gap-4">
            <NavLink to={"/home"}>
              <FaHome className="fs-18 text-white fw-bold cursor-pointer" />
            </NavLink>
            <span className="fs-18 text-white cursor-pointer">movies</span>
            <span className="fs-18 text-white cursor-pointer">Series</span>
            <span className="fs-18 text-white cursor-pointer">Tv Shows</span>
          </div>
        </div>
        <div className="notification-container">
          <NavLink to={"/notification"}>
            <div className="bell-icon-container">
              <FaRegBell className="bell-icon" />
              <span className="notification-dot"></span>
            </div>
          </NavLink>
          <NavLink to={"/search"}>
            <FaSearch className="fs-18 text-white fw-bold cursor-pointer" />
          </NavLink>
          <NavLink to={"/categories"}>
            <HiOutlineViewGrid className="grid-icon cursor-pointer" />
          </NavLink>
          <div
            onClick={toggleDropdown}
            className={`profileDropdown fs-13 ${open && "profileActive"}`}
          >
            <div className="hstack gap-1 py-2 justify-content-end">
              <img
                src={profileImage}
                alt="Profile"
                className="rounded-circle border"
                title="User Profile"
                style={{
                  width: 20,
                  height: 20,
                  objectFit: "cover",
                }}
              />
              <span className="fw-bold">Sidhant Kumar Gautam</span>
              {open ? <HiMiniChevronUp /> : <HiMiniChevronDown />}
            </div>
            <Collapse in={open}>
              <div
                className="position-absolute profileCollapse z-1 p-3 rounded "
                style={{ right: 0, top: 50, backgroundColor: "#1e293b" }}
                onClick={(e) => e.stopPropagation()}
              >
                <div>
                  <div className="position-relative">
                    <div
                      className="position-absolute cursor-pointer"
                      style={{ left: 10, top: 7 }}
                    ></div>
                    <Form.Control
                      type="text"
                      placeholder="Search Series"
                      className="profileFormControl d-flex align-item-center bg-dark rounded text-white"
                      style={{ marginBottom: 20 }}
                    />
                    <div className="passwordvisiability">
                      <LuSlidersHorizontal className="text-white fs-18 fw-bold" />
                    </div>
                  </div>
                  <div className="genre-section mt-3">
                    <h5 className="text-white">Genre</h5>
                    <div className="genre-grid">
                      {genres.map((genre) => (
                        <div
                          key={genre}
                          className={`genre-button ${
                            selectedGenres.includes(genre) ? "selected" : ""
                          }`}
                          onClick={() => handleGenreClick(genre)}
                          style={{
                            backgroundColor: selectedGenres.includes(genre)
                              ? "#0d6efd"
                              : "#334155",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {genre}
                          {selectedGenres.includes(genre) ? (
                            <FiCheck />
                          ) : (
                            <FiPlus />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainHeader;
